import { render, staticRenderFns } from "./VistaModeloLienzos.vue?vue&type=template&id=70ffed56&"
import script from "./VistaModeloLienzos.vue?vue&type=script&lang=js&"
export * from "./VistaModeloLienzos.vue?vue&type=script&lang=js&"
import style0 from "./VistaModeloLienzos.vue?vue&type=style&index=0&id=70ffed56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports